module.exports = __webpack_public_path__ + "static/media/AWS_titlePage.05f7f2f9.png";